import {FolderType} from '../kit';

export const folderEntityName: Record<FolderType, string> = {
	[FolderType.Teacher]: 'Teachers',
	[FolderType.Specialist]: 'Specialists',
};
